import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createAgent,
  deleteAgent,
  fetchAgents,
} from "../../redux/slices";
import Toast from "../../Hooks/useToast";

const isSuccessLikeMessage = (message = "") =>
  /success|created|added/i.test(String(message));

const useAgentController = () => {
  const dispatch = useDispatch();
  const { list, loading, creating, deleting } = useSelector(
    (state) => state.agent
  );

  useEffect(() => {
    dispatch(fetchAgents());
  }, [dispatch]);

  const refetchAgents = useCallback(() => {
    dispatch(fetchAgents());
  }, [dispatch]);

  const handleCreateAgent = async ({ name, email, password }) => {
    const payload = {
      name: name?.trim(),
      email: email?.trim(),
      password,
      device_type: "web",
      device_token: "web-admin-template",
      user_type: "agent",
    };

    try {
      await dispatch(createAgent(payload)).unwrap();
      Toast("Agent added successfully", "success");
      dispatch(fetchAgents());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to add agent";

      if (isSuccessLikeMessage(msg)) {
        Toast(msg, "success");
        dispatch(fetchAgents());
        return;
      }

      Toast(msg, "error");
      throw err;
    }
  };

  const handleDeleteAgent = async (id) => {
    try {
      await dispatch(deleteAgent(id)).unwrap();
      Toast("Agent deleted successfully", "success");
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to delete agent";
      Toast(msg, "error");
      throw err;
    }
  };

  return {
    values: {
      list,
      loading,
      creating,
      deleting,
    },
    functions: {
      handleCreateAgent,
      handleDeleteAgent,
      refetchAgents,
    },
  };
};

export default useAgentController;
